import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../emitter/Observer';
import { ModalResultFinalTeam } from '../../components/common/ModalResultFinalTeam';
import { audiosAssets } from '../../assets/audio';

export const SubtopicFinalTeam8 = () => {
	const { loaded } = useSelector(state => state.menu)

	useEffect(() => {
		if (loaded) {
			console.log("theme 8 final");
			ObserverEmitter.emit(EVENTS.tema8.topic2.initScene, 6);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded])
	return (
		<>
			<ModalResultFinalTeam
				title='¡Felicidades!'
				subTitle='¡Concluiste el Tema 8!'
				buttonText='Iniciar Tema 9'
				actionButton={() => {
					window.location.href = "/home9/tema9/introduction";
				}} actionBack={() => {
					window.location.href = "/home1";
				}}

			/>
		</>
	)
}


